module.exports = __webpack_public_path__ + "static/img/7-7.3d7e9761.jpeg";